// extracted by mini-css-extract-plugin
export default {"containerStyle":"styles_containerStyle__aPJvK","containerWrapperStyle":"styles_containerWrapperStyle__W2+y+","headerTextStyle":"styles_headerTextStyle__D8Bdk"};